import React, { useContext } from 'react';
import { createReducer } from 'react-use';
import { initialState, reducer } from './reducer';
import { createEventTracker } from './tag-commander-event-tracker';
import { tagCommanderMiddleware } from './tag-commander-middleware';
import { useAbTestTracking } from './use-ab-test-tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const AnalyticsDispatchContext = /*#__PURE__*/React.createContext(undefined);
const AnalyticsStateContext = /*#__PURE__*/React.createContext(initialState);
export const AnalyticsProvider = ({
  children
}) => {
  const useCustomReducer = createReducer(tagCommanderMiddleware(createEventTracker()));
  const [, dispatch] = useCustomReducer(reducer, initialState);
  useAbTestTracking(dispatch);
  return /*#__PURE__*/_jsx(AnalyticsDispatchContext.Provider, {
    value: dispatch,
    children: children
  });
};
export const useAnalyticsDispatch = () => {
  const context = useContext(AnalyticsDispatchContext);
  if (context === undefined) {
    throw new Error('useAnalyticsDispatch must be used within a AnalyticsProvider');
  }
  return context;
};
const useAnalyticsState = () => {
  const state = useContext(AnalyticsStateContext);
  if (state === undefined) {
    throw new Error('useAnalyticsState must be used within a AnalyticsProvider');
  }
  return state;
};
export const useClientSession = () => useAnalyticsState().clientSession;